<template>
  <div class="payInfo">
    <div class="content">
      <!--报名信息-->
      <van-card
        :num="orderDetail.number"
        :price="orderDetail.unitPrice.toFixed(2)"
        :desc="orderDetail.submitTime"
        :title="orderDetail.name"
        :thumb="orderDetail.mainImage"
      />
      <van-collapse v-model="activeNames" v-if="false">
        <van-collapse-item title="报名信息" name="1">
          <div class="desc" v-for="i in 3" :key="i">
            <span style="flex-shrink: 0">姓名：</span><span>11</span>
          </div>
        </van-collapse-item>
      </van-collapse>
      <!--票价信息-->
      <van-cell title="总金额" :value="'￥'+orderDetail.orderAmount.toFixed(2)"/>
      <van-cell title="订单实付金额" v-if="orderDetail.status == '1'">
        <template #right-icon>
          <span class="custom-title" style="color: #ee0a24">￥{{ orderDetail.orderAmount.toFixed(2) }}</span>
        </template>
      </van-cell>
      <van-cell class="orderSn" title="订单编号" :value="orderDetail.orderSn"/>
      <van-cell title="创建时间" :value="orderDetail.submitTime"/>
      <van-cell title="支付时间" v-if="orderDetail.status == '1'" :value="orderDetail.payTime"/>
      <van-button type="primary" v-if="orderDetail.status == '1'" @click="toHome"
                  style="width: 80%;display: block;margin: 15px auto;">返回首页
      </van-button>
      <!--      <van-cell title="当前环境" :value="isWxMini?'微信小程序':'微信浏览器'"/>-->
      <!--      <van-cell title="备注信息" :value="isWxMini?msg:''"/>-->

    </div>
    <!--去支付-->
    <van-submit-bar v-if="orderDetail.status == '0'" :price="orderDetail.orderAmount * 100" button-text="去支付"
                    @submit="onSubmit"/>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import {addLog} from "../util";

export default {
  name: 'PayInfo',
  data() {
    return {
      isWxMini: false,
      msg: "",
      activeNames: ['1'],
      orderId: 0,
      orderDetail: {
        name: '',
        mainImage: '',
        status: '',
        orderSn: '',
        payTime: '',
        submitTime: '',
        number: 1,
        unitPrice: 0,
        orderAmount: 0
      }
    }
  },
  created() {
    this.isWxMini = window.__wxjs_environment === 'miniprogram';
    this.orderId = +this.$route.query.orderId
    this.getOrderDetail()
  },
  methods: {
    getOrderDetail() {
      this.$http.post('/actOrder/myOrderById', this.orderId).then(res => {
        if (res.state == '200') {
          this.orderDetail = res.data
        } else {
          this.$toast(res.message)
        }
      })
    },
    toHome() {
      this.$router.push('/')
    },
    onSubmit() {
      if (this.isWxMini) {
        console.log("PayInfo \n当前环境：小程序 WebView")
        let url = `/jsapiPayWxMini?orderNumber=${this.orderId}&openId=${localStorage.getItem('wxminiOpenId')}`;
        console.log("支付请求参数：", url)
        addLog("微信小程序--支付请求参数", url)

        this.$http.get(url).then(res => {
          if (res.state == '200') {
            let param = JSON.stringify(res.data)
            console.log("响应数据：", res)
            addLog("微信小程序-支付-响应数据", param)

            wx.miniProgram.navigateTo({
              url: `/pages/pay/index?data=${encodeURIComponent(param)}`
              // url: `/pages/pay/index?timeStamp=${res.data.timeStamp}&nonceStr=${res.data.nonceStr}&package=${res.data.package}&signType=${res.data.signType}&paySign=${res.data.paySign}`
            });
          } else {
            addLog("微信小程序-支付-失败了", res.message)
            this.$toast(res.message)
          }
        })

      }
      //
      else {
        console.log("PayInfo \n当前环境：H5 WebView")
        this.$http.post('/jsapiPay', this.orderId).then(res => {
          if (res.state == '200') {
            this.startPay(res);
          } else {
            this.$toast(res.message)
          }
        })
      }

    },
    startPay(res) {
      wx.chooseWXPay({
        timestamp: res.data.timeStamp,
        nonceStr: res.data.nonceStr,
        package: res.data.package,
        signType: res.data.signType,
        paySign: res.data.paySign,
        success: function (res) {
          // 支付成功跳转路由(路由push无效)
          window.location.href = "https://wx.fanxingwenchuan.com/#/PayResult";
        },
        fail: (err) => {
          alert("支付失败")
        },
        cancel: (res) => {
          alert("您取消了支付")
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.payInfo {
  height: 100vh;
  background-color: #f4f5f6;

  .content {
    padding-bottom: 50px;
  }

  /deep/ .van-collapse-item__content {
    background-color: #f1f1f1;
    max-height: 400px;
    overflow-y: auto;

    .desc {
      padding: 5px 0;
      display: flex;
      align-items: flex-start;
    }
  }
}

/deep/ .van-card {
  background-color: #fff;
  margin-bottom: 10px;
}

/deep/ .van-card__content {
  .van-card__title {
    font-size: 15px;
    margin-bottom: 5px;
  }
}

.orderSn /deep/ .van-cell__value {
  flex: 3;
}
</style>



// WEBPACK FOOTER //
// src/components/PayInfo.vue